<style scoped>
    .title-line{
        font-size: 14px;
        font-weight: normal;
        line-height: 24px;
        margin: 20px 0;
        position: relative;
    }
    .index-num{
        display: inline-block;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        line-height: 25px;
        text-align: center;
        font-size: 12px;
        background: #2d8cf0;
        color: #fff;
    }
    .title-text{
        padding: 0 10px;
        position: relative;
        z-index: 1;
        background-color: #fff;
    }
    .split-line{
        display: block;
        position: absolute;
        left: 50px;
        right: 0;
        height: 0;
        border-bottom: dashed 1px #ccc;
        top:12px;
    }
</style>
<template>
   <h3 class="title-line">
       <span class="index-num">{{num}}</span>
       <span class="title-text">{{title}}</span>
       <span class="split-line"></span>
   </h3>
</template>

<script>
    export default {
        props:{
            num: {
                type: [String,Number],
                required: true
            },
            title:{
                type: String,
                required: true
            }
        },
    }
</script>

